/**
 * Тексти сторінок помилок (UX-50): «Немає доступу», «Не вдалося відкрити», «Триває оновлення»,
 * «Сторінку не знайдено». `ErrorState` бере список, тож ці тексти — у першому екрані; форма
 * «Повідомити про проблему» — у `support.ts` (лінивий чанк `ReportDialog`), перший екран її не тягне.
 * Правило текстів (states.md, розд. 3): що сталося → що зробити → код для підтримки.
 */

/** «близько 3 хв»: очікуваний час оновлення з `Retry-After`. */
const about = (seconds: number) =>
  seconds < 90 ? 'менше хвилини' : `близько ${Math.round(seconds / 60)} хв`;

export const supportPages = {
  openSearch: 'Знайти',
  notFoundText: 'Посилання застаріло або сторінку видалено. Перевірте адресу чи знайдіть потрібне.',
  noAccessTitle: 'Немає доступу',
  noAccessText: 'Для цієї сторінки не вистачає прав. Попросіть доступ в адміністратора Clientline.',
  serverTitle: 'Не вдалося відкрити сторінку',
  serverText: 'Сервер відповів помилкою. Спробуйте ще раз за хвилину.',
  offlineTitle: 'Немає зв’язку із сервером',
  offlineText:
    'Перевірте інтернет і спробуйте ще раз. Чернетки карток, нових записів і підсумків зберігаються в цій вкладці.',
  maintenanceTitle: 'Триває оновлення',
  maintenanceText: 'Clientline оновлюється, це займає кілька хвилин. Ваші дані на місці.',
  maintenanceEta: (seconds: number) => `Очікуваний час: ${about(seconds)}.`,
  maintenanceChecking: 'Перевіряємо готовність кожні 30 с. Сторінка відкриється сама.',
} as const;
